import React, { useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  entraIdCallback,
  entraIdAuthorizationError,
} from '~/store/modules/auth/login/actions';
import history from '~/services/history';
import Loading from '~/components/Loading';

const EntraIdCallback = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const alreadyDispatched = useRef(false);

  useEffect(() => {
    if (alreadyDispatched.current) {
      return;
    }

    alreadyDispatched.current = true;

    const params = new URLSearchParams(location.search);

    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');
    const errorDescription = params.get('error_description');

    if (error && state) {
      dispatch(entraIdAuthorizationError(state, error, errorDescription));

      return;
    }

    if (error || !code || !state) {
      history.push('/login', {
        entraIdError: 'Link de retorno inválido. Faça o login novamente.',
      });

      return;
    }

    dispatch(entraIdCallback(code, state));
  }, [dispatch, location.search]);

  return <Loading message="Concluindo login..." />;
};

export default EntraIdCallback;
